import React, { useRef, useState } from 'react'
import DatePicker from "react-datepicker";
import { ArrowLeftIcon, DownloadIcon, InformationCircleIcon } from '@heroicons/react/solid';
import { Tooltip } from '@mui/material';
import { CloudUploadIcon, TableIcon } from '@heroicons/react/outline';
import usePut from '../../../hooks/usePut';
import useDownloadGet from '../../../hooks/useDownloadGet';
import PrimaryLoader from '../../../components/common/PrimaryLoader';
import toast  from 'react-hot-toast';

const ReportUpload = ({ onClose }) => {
    const initialState = {
        month_year: '',
        excel_file: ''
    }
    const [uploadForm, setUploadForm] = useState(initialState)
    const handleChange = (value, name) => {
        setUploadForm((prev) => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const uploadCsv = usePut({
        url: 'mediclaimInsuranceExcelUpload',
        onSuccess: () => {
            toast.success('File Uploaded Successfully')
            onClose()
        },
        onError: () => {
            toast.error('There Was an error while uploading please try again later')
        }
    })
    
    const { reportDownload } = useDownloadGet({
        url: 'mediclaimInsuranceTemplateExcelDownload',
        filename: 'Mediclaim_Insurance_Template.xlsx',
        onError: () => {
            toast.error('Failed to download template format')
        }
    })

    const handleFileSelect = (e) => {
        let file = e.target.files[0]
        if (file) {
            handleChange(file, 'excel_file')
        }
    }

    const handleSubmitUploadForm = (e) => {
        e.preventDefault()
        uploadCsv.handleAuth.mutate(uploadForm)
    }

    const handleDownloadFormat = () => {
        reportDownload.mutate()
    }

    return (
        <>
            {(uploadCsv.handleAuth.isLoading || reportDownload.isLoading) &&
                <div className=' fixed top-0 left-0 w-full h-full flex items-center justify-center z-50 bg-[#ffffffc7]'>
                    <PrimaryLoader />
                </div>}
            <div className='bg-white w-[40%] mx-auto mt-8 rounded-md shadow-lg'>
                <div>
                    <div className=' border-b border-gray-100 px-5 flex items-center justify-between py-2'>
                        <div className='flex items-center space-x-1'>
                            <ArrowLeftIcon className='w-6 h-6 cursor-pointer' onClick={onClose} />
                            <h1 className=' text-xl font-semibold py-2'>Upload Excel</h1>
                        </div>
                        <div className='flex items-center space-x-2'>
                            <button type="button" onClick={handleDownloadFormat} className='flex items-center space-x-2 bg-orange-100 rounded-md px-4 py-2 text-sm'>
                                <DownloadIcon className='w-5 h-5' />
                                <span>Download Sample Format</span>
                            </button>
                            <Tooltip title="The Download Format contains sample data, kindly update it with actual data" placement="left" arrow>
                                <InformationCircleIcon className='w-5 h-5 text-gray-400 cursor-pointer' />
                            </Tooltip>
                        </div>
                    </div>
                    <form onSubmit={handleSubmitUploadForm}>
                        <div className='px-5 space-y-5 py-5'>
                            <div className=''>
                                <label className=' roboto label'>Select Month/Year<span className="text-red-500">*</span></label>
                                <DatePicker 
                                    required 
                                    name='month_year' 
                                    autoComplete='off' 
                                    selected={uploadForm.month_year} 
                                    onChange={(value) => handleChange(value, 'month_year')} 
                                    className='input' 
                                    dateFormat="MM/yyyy" 
                                    showMonthYearPicker 
                                    placeholderText="Select Month/Year"
                                />
                            </div>
                            
                            <div className=''>
                                <label htmlFor="file-upload" className=' roboto label'>Select File<span className="text-red-500">*</span></label>
                                <div className="relative border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-[color:var(--color1)]">
                                    <input 
                                        id="file-upload"
                                        type="file" 
                                        name="excel_file" 
                                        onChange={handleFileSelect} 
                                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" 
                                        accept=".xlsx" 
                                        required
                                    />
                                    {uploadForm.excel_file ? (
                                        <div className="flex flex-col items-center space-y-2 pointer-events-none">
                                            <TableIcon className="w-10 h-10 text-green-600" />
                                            <span className="text-sm font-medium text-gray-700">{uploadForm.excel_file.name}</span>
                                            <span className="text-xs text-gray-500">{(uploadForm.excel_file.size / 1024).toFixed(2)} KB</span>
                                        </div>
                                    ) : (
                                        <div className="flex flex-col items-center space-y-2 pointer-events-none">
                                            <CloudUploadIcon className="w-10 h-10 text-gray-400" />
                                            <span className="text-sm font-medium text-gray-600">Click here to browse file</span>
                                            <span className="text-xs text-gray-400">Accepts .xlsx files only</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <small className=' text-xs text-gray-600 block text-center'>Upload only the given file format to avoid system issues.</small>
                            <div className="flex justify-end mt-4">
                                <button type="submit" className='px-6 py-2 rounded-md bg-[color:var(--color1)] text-white font-medium hover:bg-opacity-90 transition-all'>Submit Upload</button>
                            </div>
                        </div>
                    </form>

                </div>

            </div>
        </>
    )
}

export default ReportUpload
